// Serializes an object to be used as a query string
export default function queryfy(obj: { [key: string]: any }, prefix?: string): string {
    const result: string[] = [];

    for (const p in obj) {
        if (!obj.hasOwnProperty(p)) continue;

        const k: string = prefix ? `${prefix}[${p}]` : p,
            v: any = obj[p];

        result.push((v !== null && typeof v === 'object') ?
            queryfy(v, k) :
            encodeURIComponent(k) + '=' + encodeURIComponent(v));
    }

    return result.join('&');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/queryfy.ts